export interface ExamCatalogEntry {
  id: string;            // slug, e.g. "california"
  state: string;         // display name, e.g. "California". For a non-state entry (isPathway) this is a category name, not an actual US state.
  examLabel: string;     // e.g. "CBEST, CSET (Multiple Subjects & Single Subject)"
  shortLabel: string;    // e.g. "CBEST / CSET"
  examCodes: string[];   // e.g. ["CBEST", "CSET-101", "CSET-102", "CSET-103"]
  route: string;         // e.g. "/exams/california"
  badge: string;         // e.g. "CTC Aligned"
  subtests: string;      // e.g. "CBEST (Reading, Math, Writing), CSET Multiple Subjects"
  questionsCount: string;// e.g. "120+ Diagnostic Items & Rubrics"
  highlightColor?: string;
  isPathway?: boolean;   // true for a standalone credentialing pathway that isn't tied to any one state or Praxis paper (e.g. Paraprofessional Pathway Assessment) -- changes how ExamDetailPage presents it
}

export const examCatalog: ExamCatalogEntry[] = [
  // Order matters (2026-10-07): Multi-State / National (Praxis) first, then
  // the families with practice content, then the "coming soon" states. This
  // order is used everywhere the catalog is listed.
  { 
    id: "most-other-states", 
    state: "Multi-State / National", 
    examLabel: "ETS Praxis Series (Core & Subject Tests)",
    shortLabel: "Praxis Series", 
    examCodes: ["Praxis-Core", "Praxis-Elementary", "Praxis-PLT", "Praxis-Subject"], 
    route: "/exams/praxis-series",
    badge: "ETS Official Specs",
    subtests: "Praxis Core (5713, 5723, 5733), Elementary 5001 & PLT 5622",
    questionsCount: "250+ Multi-Choice & Essay Rubrics",
    highlightColor: "indigo"
  },
  { 
    id: "california",  
    state: "California",       
    examLabel: "CBEST & CSET Multiple Subjects",
    shortLabel: "CBEST / CSET",        
    examCodes: ["CBEST", "CSET"], 
    route: "/exams/california",
    badge: "CTC Aligned",
    subtests: "CBEST (Reading, Math, Writing) & CSET Subtests I, II, III",
    questionsCount: "120+ Diagnostic Items & Rubrics",
    highlightColor: "indigo"
  },
  {
    id: "paraprofessional-pathway",
    state: "Paraprofessional Pathway",
    examLabel: "ETS Paraprofessional Pathway Assessment (ParaPathways)",
    shortLabel: "ParaPathways",
    examCodes: ["ParaPathways"],
    route: "/exams/paraprofessional-pathway",
    badge: "ETS Official Specs",
    subtests: "Reading and Writing (5758) & Mathematics (5759)",
    questionsCount: "90 Selected-Response Questions",
    highlightColor: "teal",
    isPathway: true
  },
  { 
    id: "new-york",    
    state: "New York",          
    examLabel: "NYSTCE (EAS & Multi-Subject CST)",
    shortLabel: "NYSTCE",         
    examCodes: ["NYSTCE"], 
    route: "/exams/new-york",
    badge: "NYSED Aligned",
    subtests: "Educating All Students (EAS 201) & Multi-Subject CST (221/222/245)",
    questionsCount: "90+ Questions & Constructed Rubrics",
    highlightColor: "sky"
  },
  { 
    id: "texas",       
    state: "Texas",              
    examLabel: "TExES (Core Subjects & Pedagogy)",
    shortLabel: "TExES",                            
    examCodes: ["TExES"], 
    route: "/exams/texas",
    badge: "TEA / SBEC Aligned",
    subtests: "Core Subjects EC-6 (391) & PPR EC-12 (160)",
    questionsCount: "140+ Questions & Sub-Exam Drills",
    highlightColor: "amber"
  },
  { 
    id: "florida",     
    state: "Florida",            
    examLabel: "FTCE (General Knowledge & SAE)",
    shortLabel: "FTCE",                             
    examCodes: ["FTCE"], 
    route: "/exams/florida",
    badge: "FLDOE Aligned",
    subtests: "GK Test (Essay, ELS, Reading, Math) & Elementary K-6 SAE",
    questionsCount: "110+ Diagnostic Questions & Essays",
    highlightColor: "emerald"
  },
  { 
    id: "illinois",    
    state: "Illinois",           
    examLabel: "ILTS (Licensure & Content Tests)",
    shortLabel: "ILTS",                             
    examCodes: ["ILTS"], 
    route: "/exams/illinois",
    badge: "ISBE Standards",
    subtests: "Elementary Education K-6 (702): Literacy, ELA & Biliteracy, Math, Science, Social Studies, Arts & Health",
    questionsCount: "400+ Questions & 12 Mock Exams",
    highlightColor: "purple"
  },
  { 
    id: "pennsylvania",
    state: "Pennsylvania",       
    examLabel: "PECT (PreK-4 & PAPA)",
    shortLabel: "PECT",                             
    examCodes: ["PECT", "PAPA"], 
    route: "/exams/pennsylvania",
    badge: "PDE Aligned",
    subtests: "PreK-4 Modules 1, 2, 3 & PAPA Academic Skills",
    questionsCount: "70+ Diagnostic Items",
    highlightColor: "cyan"
  },
  { 
    id: "georgia",     
    state: "Georgia",            
    examLabel: "GACE (Program Admission)",
    shortLabel: "GACE",                             
    examCodes: ["GACE"], 
    route: "/exams/georgia",
    badge: "GaPSC Aligned",
    subtests: "Reading (210), Mathematics (211), Writing (212)",
    questionsCount: "85+ Questions & Timed Tasks",
    highlightColor: "violet"
  }
];
